// ==== GPS SDK for Capacitor iframe ====

let _reqId = 0
const _callbacks = {}

function _callNative(type, payload = {}) {
  return new Promise((resolve, reject) => {
    const id = ++_reqId
    const timeout = setTimeout(() => {
      delete _callbacks[id]
      reject(new Error(`Native call ${type} timed out`))
    }, 3500)

    _callbacks[id] = (data) => {
      clearTimeout(timeout)
      resolve(data)
    }

    if (window.parent && window.parent !== window) {
      window.parent.postMessage(
        {
          type,
          payload,
          requestId: id,
        },
        '*',
      )
    } else if (window.Capacitor?.Plugins?.Geolocation) {
      if (type === 'REQUEST_LOCATION_PERMISSION') {
        window.Capacitor.Plugins.Geolocation.getCurrentPosition({ enableHighAccuracy: true })
          .then((pos) => {
            clearTimeout(timeout)
            delete _callbacks[id]
            resolve({ coords: pos?.coords })
          })
          .catch((err) => {
            clearTimeout(timeout)
            delete _callbacks[id]
            reject(err)
          })
      }
    } else {
      clearTimeout(timeout)
      delete _callbacks[id]
      reject(new Error('Native bridge not available'))
    }
  })
}

window.addEventListener('message', e => {
  const d = e.data
  if (d?.requestId && _callbacks[d.requestId]) {
    _callbacks[d.requestId](d)
    delete _callbacks[d.requestId]
  }
})

/* ================= PUBLIC API ================= */

export async function requestLocation() {
  const res = await _callNative('REQUEST_LOCATION_PERMISSION')

  if (!res?.coords) {
    throw new Error('Location permission denied')
  }

  return {
    lat: res.coords.latitude,
    lng: res.coords.longitude,
    accuracy: res.coords.accuracy,
  }
}

export function startLiveLocation(onUpdate) {
  window.addEventListener('message', e => {
    if (e.data?.type === 'DEVICE_LOCATION_UPDATE') {
      onUpdate({
        lat: e.data.payload.latitude,
        lng: e.data.payload.longitude,
        accuracy: e.data.payload.accuracy,
      })
    }
  })

  if (window.parent && window.parent !== window) {
    window.parent.postMessage({ type: 'START_LOCATION_STREAM' }, '*')
  }
}

export function stopLiveLocation() {
  if (window.parent && window.parent !== window) {
    window.parent.postMessage({ type: 'STOP_LOCATION_STREAM' }, '*')
  }
}

